// import { useTranslation } from "react-i18next";
import { useUpperSeo } from "../../../../../../../hooks";

import { TitleStyled } from "./Title.styled";

export const Title = () => {
  // const { t } = useTranslation();
  // return <TitleStyled>{ t("global.heroTitle")}</TitleStyled>;

  const { title } = useUpperSeo();
  return <TitleStyled>{title}</TitleStyled>;
};
